import context from '../../util/context';

export const NS = '@@segment';
export const ALIAS = `${NS}/alias`;
export const GROUP = `${NS}/group`;
export const IDENTIFY = `${NS}/identify`;
export const PAGE = `${NS}/page`;
export const RESET = `${NS}/reset`;
export const TRACK = `${NS}/track`;

const dispatch = (action = {}, opts = {}) => {
  const analytics = opts.analytics || context.analytics;
  if (!analytics) return;

  const { type, payload = {} } = action || {};
  const {
    category,
    name,
    userId,
    groupId,
    previousId,
    traits,
    options,
    properties,
    event
  } = payload;

  switch (type) {
    case ALIAS:
      return analytics.alias(userId, previousId, options);
    case GROUP:
      return analytics.group(groupId, traits, options);
    case IDENTIFY:
      return analytics.identify(userId, traits, options);
    case PAGE:
      return analytics.page(category, name, properties, options);
    case RESET:
      return analytics.reset();
    case TRACK:
      return analytics.track(event, properties, options);
    default:
  }
};

export default function createTracker(middleware, options = {}) {
  return store => {
    if (options.config) options.config(store);
    return next => action => {
      middleware(dispatch, store.getState(), action);
      return next(action);
    };
  };
}



// WEBPACK FOOTER //
// ./js/store/middleware/segment.js